/*
 * @Author: qh_feng
 * @Date: 2022-03-17 17:22:49
 * @LastEditTime: 2022-03-17 17:24:47
 * @LastEditors: your name
 * @Description: 
 * @ FilePath: Do not edit
 * @par 修改日志:
 * 内容:  设备管理 API
 */
export default {
  GET_menus: '/json/menus.json'
}


// WEBPACK FOOTER //
// ./src/http/apiModules/mngm.js